import { defineMessages } from 'react-intl';

const messages = defineMessages({
  featureInterestQuestionTitle: {
    description: 'title for question regarding what features the user is interested in',
    defaultMessage: 'What are you interested in exploring?',
    id: 'y7Jxj0',
  },
  featureInterestQuestionSubtitle: {
    description: 'subtitle explanation for question regarding what features the user is interested in',
    defaultMessage: "We'll guide you by recommending helpful features, automations, and tools.",
    id: 'icbsoe',
  },
  shippingVolumeQuestionTitle: {
    description: 'title for question regarding expected monthly order volume',
    defaultMessage: 'Select the monthly order volume that best describes your business.',
    id: 'DBJoqq',
  },
  companyAndPhoneQuestionTitle: {
    description: 'title welcome to ShipStation',
    defaultMessage: 'Welcome to ShipStation!',
    id: 'f1ZHO7',
  },
  companyAndPhoneQuestionSubtitle: {
    description: "subtitle for question regarding information about a user's business",
    defaultMessage: "Let's get started with a few company details.",
    id: '9Po2Ks',
  },
  phoneExplainer: {
    description: 'explanation text regarding how we use your phone number',
    defaultMessage: 'Need some help? Enter your phone number for an onboarding specialist to contact you.',
    id: 'Bl0GMY',
  },
  lessThanFifty: {
    description: 'expected monthly shipping volume of less than 50 shipments per month',
    defaultMessage: 'Less than 50',
    id: '9EFYv9',
  },
  fiftyPlus: {
    description: 'expected monthly shipping volume of 50 or more shipments per month',
    defaultMessage: '50+',
    id: 'VtWbnA',
  },
  fiveHundredPlus: {
    description: 'expected monthly shipping volume of 500 or more shipments per month',
    defaultMessage: '500+',
    id: 'YH9QvX',
  },
  oneThousandPlus: {
    description: 'expected monthly shipping volume of 1000 or more shipments per month',
    defaultMessage: '1000+',
    id: '5LPKXh',
  },
  twoThousandPlus: {
    description: 'expected monthly shipping volume of 2000 or more shipments per month',
    defaultMessage: '2000+',
    id: 'qo6eFJ',
  },
  fiveThousandPlus: {
    description: 'expected monthly shipping volume of 5000 or more shipments per month',
    defaultMessage: '5000+',
    id: '7knTsS',
  },
  seventyFiveHundredPlus: {
    description: 'expected monthly shipping volume of 7500 or more shipments per month',
    defaultMessage: '7500+',
    id: 'BZp8Dt',
  },
  continueButton: {
    description: 'button to submit forms',
    defaultMessage: 'Continue',
    id: 'jln0oQ',
  },
  backButton: {
    description: 'button to go back to previous setup page form',
    defaultMessage: 'Back',
    id: '6+8n3n',
  },
  saveSellerOnboardingJsonFailure: {
    description: 'Notification alerting user that a save of their onboarding setup information was not successful',
    defaultMessage: 'An error occurred saving your information. Please try again.',
    id: 'jGyjn/',
  },
  stepNumber: {
    description: 'informs users what step they are on',
    defaultMessage: 'Step {currentStepNumber} of {totalNumberOfSteps}',
    id: 'jLpoxi',
  },
  noOrdersYet: {
    description: 'no orders yet volume question option',
    defaultMessage: "We don't have orders yet",
    id: 'BuSk35',
  },
  justLookingAround: {
    description: 'just looking around feature interest question option',
    defaultMessage: "I'm just looking around",
    id: '70RUY/',
  },
  skip: {
    description: 'skip company name and phone question option',
    defaultMessage: 'Skip',
    id: 'seOUYR',
  },
  shoppingDiscountedRates: {
    description: 'Shopping discounted rates feature interest question option',
    defaultMessage: 'Shopping discounted rates',
    id: '5M4FSM',
  },
  importingAndManagingOrders: {
    description: 'Importing and managing orders feature interest question option',
    defaultMessage: 'Importing and managing orders',
    id: '50qhsE',
  },
  automatingShippingProcesses: {
    description: 'Automating shipping processes feature interest question option',
    defaultMessage: 'Automating shipping processes',
    id: 'jInb63',
  },
  shippingInternationally: {
    description: 'Ship internationally feature interest question option',
    defaultMessage: 'Shipping internationally',
    id: '8wUOlV',
  },
  managingReturnShipments: {
    description: 'Managing return shipments feature interest question option',
    defaultMessage: 'Managing return shipments',
    id: '50DY6d',
  },
  sendingCustomizedShipmentNotifications: {
    description: 'Sending customized shipment notifications feature interest question option',
    defaultMessage: 'Sending customized shipment notifications',
    id: 'Td/92g',
  },
  shipstationLogo: {
    description: 'ShipStation Logo alt text for image',
    defaultMessage: 'ShipStation Logo',
    id: 'I/drg2',
  },
  companyName: {
    description: 'company name field title',
    defaultMessage: 'Company Name',
    id: '1wwYGT',
  },
  phoneNumber: {
    description: 'phone number field title',
    defaultMessage: 'Phone Number',
    id: 'R4hQYg',
  },
});

export default messages;
